import { CommonModule, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule, ErrorHandler } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LaddaModule } from 'angular2-ladda';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CurrencyMaskModule, CurrencyMaskConfig } from 'ng2-currency-mask';
export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
    align: 'right', allowNegative: false, decimal: ',', precision: 2, prefix: '', suffix: '', thousands: '.'
};

import { EntidadeDataService } from './core/services/entidade-crud.service';
import { GlobalErrorHandlerService } from './shared/services/global-error-handler.service';
import { DocumentoVendaDataService } from './core/services/documentoVenda-crud.service';
import { DocumentoVendaService } from './views/documentoVenda/documentoVenda.service';
import { PedidoIntervencaoDataService } from './core/services/pedidoIntervencao-crud.service';
import { PedidoIntervencaoService } from './views/pedidoIntervencao/pedidoIntervencao.service';
import { LogisticaDataService } from './core/services/logistica-crud.service';
import { LogisticaService } from './views/logistica/logistica.service';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { Configuration } from './app.configuration.service';

import { AppComponent } from './app.component';
import { HomeComponent } from './views/home/home.component';
import { HeaderComponent } from './views/header/header.component';
import { DocumentoVendaBrowseFilterComponent } from './views/documentoVenda/browse/documentoVenda-browse-filter.component';
import { DocumentoVendaBrowseComponent } from './views/documentoVenda/browse/documentoVenda-browse.component';
import { ContratoBrowseComponent } from './views/contrato/browse/contrato-browse.component';
import { ContratoBrowseFilterComponent } from './views/contrato/browse/contrato-browse-filter.component';
import { ContratoEditComponent } from './views/contrato/edit/contrato-edit.component';
import { LogisticaBrowseFilterComponent } from './views/logistica/browse/logistica-browse-filter.component';
import { LogisticaBrowseComponent } from './views/logistica/browse/logistica-browse.component';
import { ContratoDataService } from './core/services/contrato-crud.service';
import { PedidoIntervencaoBrowseFilterComponent } from './views/pedidoIntervencao/browse/pedidoIntervencao-browse-filter.component';
import { PedidoIntervencaoBrowseComponent } from './views/pedidoIntervencao/browse/pedidoIntervencao-browse.component';
import { PedidoIntervercaoEditComponent } from './views/pedidoIntervencao/edit/pedidoIntervencao-edit.component';
import { ReferenceDataService } from './core/services/reference-data.service';

@NgModule({ declarations: [
        AppComponent,
        HomeComponent,
        HeaderComponent,
        DocumentoVendaBrowseFilterComponent,
        DocumentoVendaBrowseComponent,
        ContratoBrowseFilterComponent,
        ContratoBrowseComponent,
        ContratoEditComponent,
        PedidoIntervencaoBrowseFilterComponent,
        PedidoIntervencaoBrowseComponent,
        PedidoIntervercaoEditComponent,
        LogisticaBrowseFilterComponent,
        LogisticaBrowseComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        FontAwesomeModule,
        AppRoutingModule,
        FormsModule,
        CurrencyMaskModule,
        NgbModule,
        LaddaModule.forRoot({
            style: 'expand-right',
            spinnerSize: 23,
            spinnerColor: 'darkblue',
            spinnerLines: 12
        }),
        FontAwesomeModule], providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy // HashLocationStrategy
        },
        {
            provide: ErrorHandler,
            useClass: GlobalErrorHandlerService
        },
        Configuration,
        ReferenceDataService,
        EntidadeDataService,
        DocumentoVendaDataService,
        DocumentoVendaService,
        ContratoDataService,
        PedidoIntervencaoDataService,
        PedidoIntervencaoService,
        LogisticaDataService,
        LogisticaService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
